import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Request} from '../models/claim/Request';
import {Observable} from 'rxjs';
import {ReturnMessageDTO} from '../models/ReturnMessageDTO';
import {ClaimReviewDTO} from '../models/claim-review/ClaimReviewDTO';

@Injectable({
  providedIn: 'root'
})
export class ClaimReviewService {
  private claimUrl = environment.baseClmUrl + '/claim-review';

  constructor(private httpClient: HttpClient) {
  }

  getClaimReview(id: number): Observable<ClaimReviewDTO> {
    return this.httpClient.get<ClaimReviewDTO>(this.claimUrl + '/' + id);
  }
}
